export default "__VITE_ASSET__DgQ726gT__"